export var remToPx = function (rem, theme, withUnits) {
    if (withUnits === void 0) { withUnits = false; }
    return withUnits ? rem * theme.typography.sizes.default + "px" : rem * theme.typography.sizes.default;
};
export var spacingToRem = function (option, themeSpacingEnum, withUnits) {
    if (withUnits === void 0) { withUnits = false; }
    return (withUnits ? Number(themeSpacingEnum[option]) + "rem" : Number(themeSpacingEnum[option]));
};
//# sourceMappingURL=units.js.map